import { useDispatch } from "react-redux";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import userStore from "../../../zustand/userStore";
import { logout } from "../../../auth/authSlice";

const TicketingNavbar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);

  const logOut = () => {
    dispatch(logout());
    navigate("/home");
  };
  return (
    <nav
      className="navbar navbar-expand-lg p-0"
      style={{
        background: "linear-gradient(to right, #7B2FF7 50%, #F40076 100%)",
        fontSize: "0.85rem",
        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
      }}
    >
      <div
        className="container-fluid ps-3 mx-auto"
        style={{ maxWidth: "100%" }}
      >
        {" "}
        <button
          className="navbar-toggler mx-2"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav w-100 d-flex justify-content-start gap-3">
            <li
              className={`nav-item ${
                ["/dashboard"].includes(pathname) ? "active" : ""
              }`}
            >
              <Link to="/dashboard" className="nav-link text-white">
                <i className="fa fa-home" style={{ pointerEvents: "none" }}></i>{" "}
                Home
              </Link>
            </li>
            <li
              className={`nav-item ${
                ["/viewTickets"].includes(pathname) ? "active" : ""
              }`}
            >
              <Link to="/viewTickets" className="nav-link text-white">
                <i
                  className="fa fa-list-alt"
                  style={{ pointerEvents: "none" }}
                ></i>{" "}
                View Tickets
              </Link>
            </li>
            <li
              className={`nav-item ${
                ["/createTicket"].includes(pathname) ? "active" : ""
              }`}
            >
              <Link to="/createTicket" className="nav-link text-white">
                <i
                  className="fa fa-plus-circle"
                  style={{ pointerEvents: "none" }}
                ></i>{" "}
                Create Tickets{" "}
              </Link>
            </li>
          </ul>
        </div>
        <div className="d-flex align-items-center justify-content-end gap-3">
          <div className="dropdown me-3">
            <button
              className="btn btn-light dropdown-toggle d-flex align-items-center"
              type="button"
              id="userDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-user me-2"></i>
              {userData.name}
            </button>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="userDropdown"
            >
              <li>
                <span className="dropdown-item">Profile</span>
              </li>
              {/* <li>
                <span className="dropdown-item d-flex justify-content-between align-items-center">
                  Settings
                  <span
                    style={{
                      backgroundColor: "#ff4444",
                      borderRadius: "10px",
                      padding: "2px 8px",
                      color: "white",
                      fontSize: "12px",
                    }}
                  >
                    50%
                  </span>
                </span>
              </li>
              <li>
                <span className="dropdown-item">Help</span>
              </li> */}
              <li>
                <span className="dropdown-item" onClick={logOut}>
                  <i className="fa fa-sign-out me-2"></i>
                  Log Out
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <style jsx>{`
        .nav-item.active .nav-link {
          font-weight: 600;
          background-color: #f3e5f5;
          color: #7b2ff7 !important;
          border-radius: 4px;
        }
        .active-indicator {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 3px;
          background: #bbdefb; /* Light blue indicator */
          transition: width 0.3s ease;
        }
        .nav-item.active .active-indicator {
          width: 80%;
        }
        .nav-link {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          transition: all 0.3s ease;
          border-radius: 4px;
        }
        .hover-effect:hover {
          background-color: rgba(255, 255, 255, 0.15);
          transform: translateY(-2px);
        }
        .nav-item.active .hover-effect:hover {
          background-color: rgba(255, 255, 255, 0.25);
        }
        .navbar-nav {
          gap: 0.5rem;
        }
      `}</style>
    </nav>
  );
};

export default function TicketingLayout() {
  return (
    <div className="container-fluid vh-100 d-flex flex-column p-0">
      {/* <Header2 /> */}

      <div className="row flex-grow-1 m-0 overflow-hidden">
        <div className="col-12 p-0 d-flex flex-column h-100">
          <TicketingNavbar />
          <div
            className="flex-grow-1 overflow-hidden d-flex"
            style={{
              position: "relative",
              background:
                "linear-gradient(to bottom, #ffffff 40%, #B9D9F0 100%)",
            }}
          >
            <div
              style={{
                content: "''",
                backgroundImage: `url('/images/schoold-home-banner.png')`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "50%",
                opacity: 0.15,
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 0,
              }}
            />
            <div
              className="overflow-auto w-100 py-3 px-5"
              style={{
                zIndex: 1,
                position: "relative",
              }}
            >
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
